import { render } from "./ImagensCrm.vue?vue&type=template&id=3d983fb2"
import script from "./ImagensCrm.vue?vue&type=script&lang=js"
export * from "./ImagensCrm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__